<script lang="ts">
	export let data;
</script>

<svelte:component this={data.content} context={data.context} metadata={data.metadata} />
